<div mat-dialog-title>
  <div class="d-flex bd-highlight">
  
    <div class="user_info">
      <span class="line-1" *ngIf="this.data && this.data.username" [title]="this.data && this.data.username">Chat with
        {{this.data.username ||
        'User'}}
        <ng-container *ngIf="this.data && this.data.refId && this.data.refId.length>1">
          +{{this.data.refId.length-1}} more
        </ng-container>

      </span>
      <ng-container *ngIf="data && (data.view_type==2 ||data.view_type==3) && !this.data.multi_notes">
        <span class="line-1" [title]="this.data && this.data.heading" *ngIf="this.data && this.data.heading">
          {{this.data.heading }}
          <ng-container *ngIf="this.data && this.data.refId && this.data.refId.length>1">
            +{{this.data.refId.length-1}} more
          </ng-container>
        </span>

      </ng-container>
      <ng-container *ngIf="data &&( data.view_type==2 ) && this.data.multi_notes">
        <span class="line-1" [title]="this.data && this.data.heading" *ngIf="this.data && this.data.heading">
          <i class="fa fa-angle-double-left mx-1"></i> {{this.data.heading }} <i
            class="fa mx-1 fa-angle-double-right"></i> </span>
      </ng-container>

      <p class="mb-1" *ngIf="total_messages_list.length">{{total_messages_list.length}} Messages</p>
    </div>
    <!-- <div class="video_cam">
      <span><i class="fa fa-video"></i></span>
      <span><i class="fa fa-phone"></i></span>
    </div> -->
    <div class="ml-auto pointer" (click)="closeChat()">
      <span class="btn btn-sm btn-default">
        <i class="fa fa-close close-1 "></i>
      </span>
    </div>
  </div>
  <span class="float-right pointer" (click)="closeChat()">
    <i class="fa fa-close"></i>
  </span>
</div>
<mat-dialog-content>
  <div class="chat-container">
    <div class="row justify-content-center h-100">

      <div class="col-md-12 p-0 col-xl-12 chat">
        <div class="card">
          <div *ngIf="false" class="card-header msg_head">
            <div class="d-flex bd-highlight">
              <div class="img_cont">
                <img src="https://therichpost.com/wp-content/uploads/2020/06/avatar2.png"
                  class="rounded-circle user_img">
                <span class="online_icon"></span>
              </div>
              <div class="user_info">
                <span class="line-1" *ngIf="this.data && this.data.username"
                  [title]="this.data && this.data.username">Chat with {{this.data.username ||
                  'User'}}
                  <ng-container *ngIf="this.data && this.data.refId && this.data.refId.length>1">
                    +{{this.data.refId.length-1}} more
                  </ng-container>

                </span>
                <ng-container *ngIf="data && data.view_type==2 && !this.data.multi_notes">
                  <span class="line-1" [title]="this.data && this.data.heading" *ngIf="this.data && this.data.heading">
                    {{this.data.heading }}
                    <ng-container *ngIf="this.data && this.data.refId && this.data.refId.length>1">
                      +{{this.data.refId.length-1}} more
                    </ng-container>
                  </span>

                </ng-container>
                <ng-container *ngIf="data && data.view_type==2 && this.data.multi_notes">
                  <span class="line-1" [title]="this.data && this.data.heading" *ngIf="this.data && this.data.heading">
                    <i class="fa fa-angle-double-left mx-1"></i> {{this.data.heading }} <i
                      class="fa mx-1 fa-angle-double-right"></i> </span>
                </ng-container>

                <p *ngIf="total_messages_list.length">{{total_messages_list.length}} Messages</p>
              </div>
              <!-- <div class="video_cam">
                <span><i class="fa fa-video"></i></span>
                <span><i class="fa fa-phone"></i></span>
              </div> -->
              <div class="ml-auto pointer" (click)="closeChat()">
                <span class="btn btn-sm btn-default">
                  <i class="fa fa-close close-1 "></i>
                </span>
              </div>
            </div>
            <!-- <span id="action_menu_btn"><i class="fa fa-ellipsis-v"></i></span>
            <div class="action_menu">
              <ul>
                <li><i class="fa fa-user-circle"></i> View profile</li>
                <li><i class="fa fa-users"></i> Add to close friends</li>
                <li><i class="fa fa-plus"></i> Add to group</li>
                <li><i class="fa fa-ban"></i> Block</li>
              </ul>
            </div> -->
          </div>
          <div class="card-body msg_card_body">
            <ng-container *ngFor="let chat of total_messages_list;let i =index">
              <div class="d-flex justify-content-start mb-4 message-thread" [id]="'chat'+i" *ngIf="chat.isJS">

                <div class="user-icon">
                  <div class="chat-by-name">
                    {{chat.createdBy[0]}}
                  </div>
                </div>

                <div class="msg_cotainer">
                  <span> {{chat.notes}} </span>
                  <span class="msg_time">By {{chat.createdBy}} on
                    {{chat.crDate| UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}} </span>
                </div>
              </div>
              <div [ngClass]="{'message-thread':!chat.deleted}" class="d-flex justify-content-end mb-4 message-thread"
                [id]="'chat'+i" *ngIf="!chat.isJS">
                <div class="msg_cotainer_send">
                  <span> {{chat.notes}} </span>
                  <span class="msg_time_send">By {{chat.createdBy}} on
                    {{chat.crDate| UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}} </span>
                </div>

                <div class="user-icon pointer" [matMenuTriggerFor]="!chat.deleted ?actionList :noAction">
                  <div class="chat-by-name">
                    {{chat.createdBy[0]}}
                  </div>
                  <div class="action" [matMenuTriggerFor]="actionList" *ngIf="!chat.deleted">
                    <i class="fa fa-ellipsis-v"></i>
                  </div>
                </div>
                <mat-menu #actionList="matMenu">
                  <div mat-menu-item (click)="editMessage(chat)"> <i class="fa fa-pencil mx-2"></i>
                    {{"BTN.edit"|translate}} </div>
                  <div mat-menu-item (click)="deleteMessage(chat)"> <i class="fa fa-trash mx-2"></i>
                    {{"BTN.delete"|translate}} </div>
                </mat-menu>
                <mat-menu #noAction="matMenu">
                </mat-menu>
                <!-- <div class="img_cont_msg">
                  <img src="https://therichpost.com/wp-content/uploads/2020/06/avatar2.png"
                    class="rounded-circle user_img_msg">
                </div> -->
              </div>
            </ng-container>

          </div>
          <div class="card-footer" *ngIf="false">
            <form [formGroup]="message_form">
              <div class="input-group">
                <!-- <div class="input-group-append">
                  <span class="input-group-text attach_btn"><i class="fa fa-paperclip"></i></span>
                </div> -->
                <input formControlName="notes" class="form-control" placeholder="Type your message...">
                <div class="input-group-append" (click)="cancel()" *ngIf="message_form.value.isEdit">
                  <button type="submit" class="js-btn-save btn" [title]="'Cancel' |translate">
                    <i class="fa fa-close "></i>
                  </button>
                </div>
                <div class="input-group-append" (click)="sendMessage()">
                  <button type="submit" class="js-btn-save btn" [title]="'Send' |translate" [disabled]="loader">
                    <i class="fa fa-location-arrow" *ngIf="!loader"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loader"></i>
                  </button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <form [formGroup]="message_form" class="w-100">
    <div class="row">
      <div class="col-md-12">
        <div class="input-group">
          <!-- <div class="input-group-append">
            <span class="input-group-text attach_btn"><i class="fa fa-paperclip"></i></span>
          </div> -->
          <input formControlName="notes" class="form-control" placeholder="Type your message...">
          <div class="input-group-append" (click)="cancel()" *ngIf="message_form.value.isEdit">
            <span class="js-btn-cancel btn" [title]="'Cancel' |translate">
              <i class="fa fa-close "></i>
            </span>
          </div>
          <div class="input-group-append" (click)="sendMessage()">
            <button type="submit" class="js-btn-save btn mx-1" [title]="'Send' |translate" [disabled]="loader">
              <i class="fa fa-location-arrow" *ngIf="!loader"></i>
              <i class="fa fa-spinner fa-spin" *ngIf="loader"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

  </form>

</mat-dialog-actions>